import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { cn } from '../../lib/cn';
const DimmedBackdrop = ({ className, ...props }) => {
    return (_jsx(motion.div, { "aria-hidden": "true", className: cn('dimmed-backdrop-layer fixed inset-0 z-10 bg-black', className), ...props }));
};
export default DimmedBackdrop;
